/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthClient } from './OAuthClient';
import {
    OAuthClientFromJSON,
    OAuthClientFromJSONTyped,
    OAuthClientToJSON,
    OAuthClientToJSONTyped,
} from './OAuthClient';
import type { OAuthCodeUser } from './OAuthCodeUser';
import {
    OAuthCodeUserFromJSON,
    OAuthCodeUserFromJSONTyped,
    OAuthCodeUserToJSON,
    OAuthCodeUserToJSONTyped,
} from './OAuthCodeUser';
import type { OAuthScopes } from './OAuthScopes';
import {
    OAuthScopesFromJSON,
    OAuthScopesFromJSONTyped,
    OAuthScopesToJSON,
    OAuthScopesToJSONTyped,
} from './OAuthScopes';

/**
 * 
 * @export
 * @interface OAuthCode
 */
export interface OAuthCode {
    /**
     * 
     * @type {string}
     * @memberof OAuthCode
     */
    authorizationCode: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthCode
     */
    expiresAt: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthCode
     */
    redirectUri: string;
    /**
     * 
     * @type {OAuthClient}
     * @memberof OAuthCode
     */
    client: OAuthClient;
    /**
     * 
     * @type {OAuthCodeUser}
     * @memberof OAuthCode
     */
    user: OAuthCodeUser;
    /**
     * 
     * @type {Array<OAuthScopes>}
     * @memberof OAuthCode
     */
    scope: Array<OAuthScopes>;
}

/**
 * Check if a given object implements the OAuthCode interface.
 */
export function instanceOfOAuthCode(value: object): value is OAuthCode {
    if (!('authorizationCode' in value) || value['authorizationCode'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('redirectUri' in value) || value['redirectUri'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    return true;
}

export function OAuthCodeFromJSON(json: any): OAuthCode {
    return OAuthCodeFromJSONTyped(json, false);
}

export function OAuthCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthCode {
    if (json == null) {
        return json;
    }
    return {
        
        'authorizationCode': json['authorizationCode'],
        'expiresAt': json['expiresAt'],
        'redirectUri': json['redirectUri'],
        'client': OAuthClientFromJSON(json['client']),
        'user': OAuthCodeUserFromJSON(json['user']),
        'scope': ((json['scope'] as Array<any>).map(OAuthScopesFromJSON)),
    };
}

export function OAuthCodeToJSON(json: any): OAuthCode {
    return OAuthCodeToJSONTyped(json, false);
}

export function OAuthCodeToJSONTyped(value?: OAuthCode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authorizationCode': value['authorizationCode'],
        'expiresAt': value['expiresAt'],
        'redirectUri': value['redirectUri'],
        'client': OAuthClientToJSON(value['client']),
        'user': OAuthCodeUserToJSON(value['user']),
        'scope': ((value['scope'] as Array<any>).map(OAuthScopesToJSON)),
    };
}

